export const AccessExpirationActions = {
  RENEW: 'renew',
  ACTIVATE: 'activate',
} as const;
export type TAccessExpirationAction = (typeof AccessExpirationActions)[keyof typeof AccessExpirationActions];
